import { render, staticRenderFns } from "./LimitedComponentView.vue?vue&type=template&id=824757dc&scoped=true"
import script from "./LimitedComponentView.vue?vue&type=script&lang=js"
export * from "./LimitedComponentView.vue?vue&type=script&lang=js"
import style0 from "./LimitedComponentView.vue?vue&type=style&index=0&id=824757dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824757dc",
  null
  
)

export default component.exports